
<div class="w-100">
  <iframe width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
          src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=26/1+Strand+Road&amp;aq=&amp;sll=22.570932,88.344283&amp;sspn=0.005023,0.010568&amp;ie=UTF8&amp;hq=&amp;hnear=26/1,+Strand+Rd,+Fairley+Place,+B+B+D+Bagh,+Kolkata,+West+Bengal,+India&amp;ll=22.578456,88.348&amp;spn=0.002511,0.005284&amp;t=m&amp;z=14&amp;output=embed"></iframe>
</div>

<div class="pt-4 container">
  <div class="">
    <h2>Contact us</h2>
    <h3>For detailed locations please refer catalogue in downloads section</h3>

  </div>
  <div class="d-flex align-items-stretch mb-4">
    <div class="col shadow mr-3 rounded">
      <address class="p-3">
        <strong>Head office</strong><br>
        26/1 Strand Road<br>
        Kolkata - 700001<br>
        India<br>
        <abbr >Phone:</abbr> +91-8584944220<br>
        Email: <a href="mailto:rj_1804@yahoo.com">rj_1804@yahoo.com</a>
      </address>
    </div>
    <div class="col shadow mr-3 rounded">
      <address class="p-3">
      <strong>Registered Works</strong><br>
        NH6, Ankurhati<br>
        Beside Kolkata International Haat<br> Howrah - 711409<br>
        India<br>
        <abbr >Phone:</abbr> +91-8584944220<br>
        Email: <a href="mailto:rahul@jindalforging.com">rahul@jindalforging.com</a>
      </address>
    </div>
    <div class="col shadow rounded">
      <address class="p-3">
      <strong>Warehouse</strong><br>
        121/1 J.N. Mukherjee Road<br>
        Ghusuri<br>Howrah - 711107<br>
        India<br>
        <abbr >Phone:</abbr> +91-33-22106583<br>
        Email: <a href="mailto:jindalforging@eth.net">jindalforging@eth.net</a>
      </address>
    </div>
  </div>
</div>

